import React from 'react';

import { HASH_SUFFIX } from '../utils/constant';

const scrollToWithOffset = (el) => {
  const targetPos = el.getBoundingClientRect().top;
  const startPos = window.pageYOffset;
  const duration = 472.143 * Math.log(Math.abs(startPos - targetPos) + 125) - 2700;
  let startTime = null;

  const ease = (t, b, c, d) => {
    const time = t / d;
    return -c * time * (time - 2) + b;
  };

  const animation = (currentTime) => {
    if (startTime === null) startTime = currentTime;

    const timeElapsed = currentTime - startTime;
    const run = ease(timeElapsed, startPos, targetPos, duration);
    window.scrollTo(0, run);
    if (timeElapsed < duration) requestAnimationFrame(animation);
  };

  requestAnimationFrame(animation);
};

export default class ScrollToHash extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      element: '',
    };
  }

  componentDidMount() {
    const id = window.location.hash.replace('#', '');
    window.location.hash = '';

    if (id) {
      const element = document.getElementById(id) || document.getElementById(`${id}${HASH_SUFFIX}`);
      if (element) {
        if (!element.id.endsWith(HASH_SUFFIX)) element.id += HASH_SUFFIX;
        window.location.hash = id;
        this.setState({
          element,
        });
        if (document.readyState === 'loading') {
          window.addEventListener('DOMContentLoaded', this.handleScroll);
        } else {
          this.handleScroll();
        }
      }
    } else {
      this.renameSectionIds();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('DOMContentLoaded', this.handleScroll);
  }

  renameSectionIds = () => {
    const elements = document.querySelectorAll(`[id$=${HASH_SUFFIX}]`);
    if (elements && elements.length) {
      elements.forEach((el) => {
        el.id = el.id.replace(HASH_SUFFIX, '');
      });
    }
  };

  handleScroll = () => {
    setTimeout(() => {
      if (this.state.element) {
        setTimeout(() => {
          if (this.state.element) {
            scrollToWithOffset(this.state.element);
          }
        }, 1000);
        this.renameSectionIds();
      }
    }, 0);
  };

  render() {
    return null;
  }
}
